export default "__VITE_ASSET__DWVnbm2C__"